import { wrapWithImageContainer } from '@helpers/utils';
const {
  i18n: { __ },
  components: { ToolbarGroup, ToolbarButton },
  blockEditor: { BlockControls, store: blockEditorStore },
  data: { useSelect },
} = wp;

const ImageToContainer = ({ clientId, icon = 'format-image' }) => {
  const blockAncestors = useSelect((select) =>
    select(blockEditorStore).getBlockParentsByBlockName(clientId, [
      'b3rg/mobile-content',
      'b3rg/image-container',
    ]),
  );
  const imageContainerSwitcherAllowed = blockAncestors.length === 0;
  return (
    imageContainerSwitcherAllowed && (
      <BlockControls>
        <ToolbarGroup>
          <ToolbarButton
            icon={icon}
            label={__('Add a mobile specific image', 'b3rg')}
            onClick={() => wrapWithImageContainer(clientId)}
          />
        </ToolbarGroup>
      </BlockControls>
    )
  );
};

export default ImageToContainer;
